export enum TasksKanbanTeam {
  Support = 'SUPPORT',
  Success = 'SUCCESS',
  Billing = 'BILLING',
}

export enum TasksKanbanRelatedToType {
  Customer = 'CUSTOMER',
  Discipline = 'DISCIPLINE',
  Subscription = 'SUBSCRIPTION',
}

export enum TaskType {
  AutorenewFailed = 'AUTORENEW_FAILED',
  AutoCanceledSubscription = 'AUTO_CANCELED_SUBSCRIPTION',
  CallbackRequest = 'CALLBACK_REQUEST',
  CancelSubscription = 'CANCEL_SUBSCRIPTION',
  ChangeSchedule = 'CHANGE_SCHEDULE',
  ChangeTutor = 'CHANGE_TUTOR',
  Chargeback = 'CHARGEBACK',
  CustomRequest = 'CUSTOM_REQUEST',
  DowngradeSubscription = 'DOWNGRADE_SUBSCRIPTION',
  FailedPayment = 'FAILED_PAYMENT',
  FirstLessonCancellation = 'FIRST_LESSON_CANCELLATION',
  FirstLessonCancellationTutor = 'FIRST_LESSON_CANCELLATION_TUTOR',
  HealthCheck = 'HEALTH_CHECK',
  InvoiceCreation = 'INVOICE_CREATION',
  Onboarding = 'ONBOARDING',
  ManualActivation = 'MANUAL_ACTIVATION',
  PauseSubscription = 'PAUSE_SUBSCRIPTION',
  RefundSubscription = 'REFUND_SUBSCRIPTION',
  ResumeSubscription = 'RESUME_SUBSCRIPTION',
  SubstituteTutor = 'SUBSTITUTE_TUTOR',
  SuccessBadFeedback = 'SUCCESS_BAD_FEEDBACK',
  SupportBadFeedback = 'SUPPORT_BAD_FEEDBACK',
  TechnicalIssue = 'TECHNICAL_ISSUE',
  UpgradeSubscription = 'UPGRADE_SUBSCRIPTION',
}
